import { Alert, Steps } from "antd";
import { useTranslation } from "react-i18next";
import DeviceConfigurationEmbed from "./DeviceConfigurationEmbed";
import "../home/create_device_modal/style.scss";

interface WiFiConfigurationStepsProps {
  currentStep: number;
  onPopupStateChange?: (isOpen: boolean) => void;
  hideInternalSteps?: boolean;
  wifiSsid?: string;
}

const DEFAULT_WIFI_SSID = "Soliseco";

const WiFiConfigurationSteps = ({
  currentStep,
  onPopupStateChange,
  hideInternalSteps = false,
  wifiSsid = DEFAULT_WIFI_SSID,
}: WiFiConfigurationStepsProps) => {
  const { t } = useTranslation("home");
  const ssid = wifiSsid || DEFAULT_WIFI_SSID;

  const steps = [
    {
      title: t("wizard_step_2_title"),
      description: t("wizard_step_2_description"),
    },
    {
      title: t("wizard_step_3_title"),
      description: t("wizard_step_3_description"),
    },
  ];

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <div className="wifi-selection-step">
            <Alert
              message={t("wizard_wifi_connection_instructions_title")}
              description={t("wizard_wifi_connection_instructions", { wifiSsid: ssid })}
              type="info"
              showIcon
              style={{ marginBottom: '24px' }}
            />
            <div style={{ 
              padding: '20px', 
              backgroundColor: '#f5f5f5', 
              borderRadius: '8px',
              border: '1px solid #d9d9d9'
            }}>
              <h4 style={{ marginTop: 0, marginBottom: '12px' }}>{t("wizard_wifi_connection_steps_title")}</h4>
              <ol style={{ margin: 0, paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>{t("wizard_wifi_connection_step_1")}</li>
                <li style={{ marginBottom: '8px' }}>{t("wizard_wifi_connection_step_2", { wifiSsid: ssid })}</li>
                <li style={{ marginBottom: '8px' }}>{t("wizard_wifi_connection_step_3", { wifiSsid: ssid })}</li>
                <li style={{ marginBottom: '8px' }}>{t("wizard_wifi_connection_step_4", { wifiSsid: ssid })}</li>
                <li>{t("wizard_wifi_connection_step_5")}</li>
              </ol>
            </div>
            <Alert
              message={t("wizard_wifi_connection_note_title")}
              description={t("wizard_wifi_connection_note", { wifiSsid: ssid })}
              type="warning"
              showIcon
              style={{ marginTop: '20px' }}
            />
          </div>
        );
      case 1:
        return (
          <div className="wifi-config-step">
            <p style={{ marginBottom: '16px' }}>{t("wizard_configuring_home_wifi")}</p>
            <DeviceConfigurationEmbed
              onPopupStateChange={onPopupStateChange}
              fallbackTitle={t("wizard_configuring_home_wifi")}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {!hideInternalSteps && (
        <Steps current={currentStep} items={steps} style={{ marginBottom: '32px' }} />
      )}
      {renderStepContent()}
    </>
  );
};

export default WiFiConfigurationSteps;

